import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    selectWorkspace: string;
    helpText: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the workspace picker field */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspacePicker.title?c=fvis4ig6qtg3", defaultMessage: "Workspace" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Placeholder text for selecting a workspace */
            selectWorkspace: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspacePicker.selectWorkspace?c=3bhc219imoavr", defaultMessage: "Select a Workspace" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Help text explaining that workspace cannot be changed */
            helpText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspacePicker.helpText?c=3c3w9vxxtkvlj", defaultMessage: "A Project''s Workspace can''t be changed." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
